<app-modal-basic #modal (closed)="fechar()" [allowClickOutside]="allowClickOutside">
  <div class="app-modal-header">
    <h4 class="modal-title" style="text-align: center;">
      <i class="fa fa-calculator"></i> {{tituloModal}}
    </h4>
  </div>

  <div class="app-modal-body">
    <div class="form-group mb-0">
      <div class="d-flex justify-content-center align-items-center py-5" *ngIf="loading['request']">
        <i class="fa fa-circle-notch fa-spin fa-3x text-primary"></i>
      </div>
      <form [formGroup]="cadastroForm" *ngIf="!loading['request']">
        <div style="max-height: 400px">

          <app-dim-checkbox-list [formLabels]="formLabels" colSize="col-12" [validacao]="false" [mostrarErro]="false">
          </app-dim-checkbox-list>
        </div>

        <div class="d-flex flex-column mt-4">
          <div class="d-flex justify-content-end align-items-center pt-2 border-top gap-4">
            <div class="small">
              <span *ngIf="loading['salvando']" class="d-flex align-items-center" style="height: 50px;">
                <i class="fa fa-circle-o-notch fa-spin"></i> Salvando...
              </span>
              <span *ngIf="!loading['salvando'] && hasChanges" class="d-flex align-items-center" style="height: 50px;">
                <i class="fa fa-check ml-1 mr-1"></i> Salvo
              </span>
            </div>

            <div class="d-flex justify-content-end mb-2 align-items-center gap-2"
              style="height: 50px; margin-block: 0 !important;">
              <span class="font-weight-bold text-muted">Total: </span>
              <span class="mb-0 font-weight-bold">{{ valorCampoCalculado | currency:'R$' }}</span>
            </div>

            <button class="btn btn-secondary m-0" (click)="fechar()" type="button" [disabled]="loading['salvando']">
              <i class="fa fa-times-circle"></i> Fechar
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</app-modal-basic>